function makeDefaultAvailLink(link, applyText, useNewTab, isUnit=false) {
    let a = document.createElement("a"),
        div = document.createElement("div"),
        text = document.createTextNode(applyText),
        unitClassList =  "application-link lined-box";

    if (isUnit) {
        unitClassList = `${unitClassList} apply-unit`;
    }

    a.setAttribute("href", link);

    if (useNewTab) {
        a.setAttribute("target", "_blank");
    }

    a.setAttribute("class", "button btn");

    div.setAttribute("class", unitClassList);
    a.appendChild(text);
    div.appendChild(a);

    return div.outerHTML;
}

function makeContactForm(contactFormText, unit) {
    const a = document.createElement("a"),
        div = document.createElement("div"),
        text = document.createTextNode(contactFormText),
        unitClassList =  "application-link lined-box",
        floorPlan = unit.get("floor_plan");

    a.setAttribute("href", "#");
    a.setAttribute("class", "button btn");

    div.setAttribute("class", "application-link lined-box notify-me");
    a.appendChild(text);
    div.appendChild(a);

    return div.outerHTML;
}

function isCoreLogicLink(link) {
    // Link must end with this hostname (no paths, query params)
    return link.match(/leasingmanager\.net\/?$/i);
}

function makeCoreLogicForm(rawLink, applyText, unit, useNewTab, isUnit=false) {
    let floorPlanField, moveInDateField, link,
        unitNumber = getCoreLogicUnitNumber(unit),
        moveInDate = getCoreLogicMoveInDate(unit),
        floorPlan = unit.get("floor_plan"),
        linkPath = "api/v2/public/external/unit",
        form = document.createElement("form"),
        numberField = document.createElement("input"),
        submitButton = document.createElement("button"),
        div = document.createElement("div"),
        unitClassList = "application-link lined-box";

    if (isUnit) {
        unitClassList = `${unitClassList} apply-unit`;
    }

    if (!rawLink.endsWith("/")) {
        linkPath = "/" + linkPath;
    }
    link = rawLink + linkPath;

    div.setAttribute("class", unitClassList);

    form.setAttribute("action", link);
    form.setAttribute("method", "POST");

    if (useNewTab) {
        form.setAttribute("target", "_blank");
    }

    numberField.setAttribute("name", "unit");
    numberField.setAttribute("type", "hidden");
    numberField.setAttribute("value", unitNumber);
    form.appendChild(numberField);

    if (floorPlan) {
        floorPlanField = document.createElement("input");
        floorPlanField.setAttribute("name", "floorplan");
        floorPlanField.setAttribute("type", "hidden");
        floorPlanField.setAttribute("value", floorPlan);
        form.appendChild(floorPlanField);
    }

    if (moveInDate) {
        moveInDateField = document.createElement("input");
        moveInDateField.setAttribute("name", "moveInDate");
        moveInDateField.setAttribute("type", "hidden");
        moveInDateField.setAttribute("value", moveInDate);
        form.appendChild(moveInDateField);
    }

    submitButton.setAttribute("class", "button btn");
    submitButton.appendChild(document.createTextNode(applyText));

    form.appendChild(submitButton);
    div.appendChild(form);

    return div.outerHTML;
}

function getCoreLogicUnitNumber(unit) {
    let number = unit.get("corelogic_unit_number");

    if (!number) {
        number = unit.get("number");
    }

    return number;
}

function getCoreLogicMoveInDate(unit) {
    return unit.get("corelogic_move_in_date");
}

export {makeCoreLogicForm, makeDefaultAvailLink, makeContactForm, isCoreLogicLink};
